import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BookmarkService } from '../../services';
import { BookmarkDialogComponent } from '../bookmark-dialog/bookmark-dialog.component';

@Component({
  selector: 'lib-tool-page-layout',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatDialogModule,
    RouterModule
  ],
  templateUrl: './tool-page-layout.html',
  styleUrl: './tool-page-layout.css',
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ToolPageLayout {
  private readonly bookmarkService = inject(BookmarkService);
  private readonly dialog = inject(MatDialog);
  /** The title of the tool */
  @Input({ required: true }) title!: string;

  /** A brief description of what the tool does */
  @Input({ required: true }) description!: string;

  /** The icon of the tool */
  @Input() icon?: string;

  /** Whether the header section should be visible */
  @Input() showHeader = true;

  /** Whether the copy button should be visible */
  @Input() showCopy = true;

  /** Whether the clear button should be visible */
  @Input() showClear = true;

  /** Whether the copy button is disabled */
  @Input() copyDisabled = false;

  /** Whether the bookmark button should be visible */
  @Input() showBookmark = true;

  /** Emits when the copy button is clicked */
  @Output() copyContent = new EventEmitter<void>();

  /** Emits when the clear button is clicked */
  @Output() clearContent = new EventEmitter<void>();

  onCopy() {
    this.copyContent.emit();
  }

  onClear() {
    this.clearContent.emit();
  }

  onBookmark() {
    this.bookmarkService.bookmarkPage(this.title, this.description);
  }

  downloadPack() {
    this.dialog.open(BookmarkDialogComponent, {
      maxWidth: '500px',
      panelClass: 'modern-dialog'
    });
  }
}
